import { useState, useEffect, SetStateAction, Dispatch } from 'react';
import type SuccessToast from '@alltrails/shared/types/successToast';

export default function useReportingToast(): [SuccessToast, Dispatch<SetStateAction<SuccessToast>>] {
  const [reportingSuccessToast, setReportingSuccessToast] = useState<SuccessToast>({ isVisible: false, text: '' });

  useEffect(() => {
    if (reportingSuccessToast.isVisible) {
      setTimeout(() => {
        setReportingSuccessToast({ isVisible: false, text: '' });
      }, 3000);
    }
  }, [reportingSuccessToast.isVisible]);

  return [reportingSuccessToast, setReportingSuccessToast];
}
